export default __webpack_public_path__ + "static/media/animated_heartbeat.e19c343a.gif";